// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock1-space1-wT1jy {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock1-space2-hM07m {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock1-space3-ZWyvZ {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock1-space4-kIDpD {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock1-space5-MsCty {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock1-space6-xMXbQ {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock1-space7-hsluk {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock1-space8-ls0zu {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock1-spaceTop1-a7BVs {
	margin-top: 6px !important;
}

.WhyHostFormBlock1-spaceTop2-yq5NB {
	margin-top: 12px !important;
}

.WhyHostFormBlock1-spaceTop3-hvqan {
	margin-top: 18px !important;
}

.WhyHostFormBlock1-spaceTop4-N9ihC {
	margin-top: 24px !important;
}

.WhyHostFormBlock1-spaceTop5-wSB1Z {
	margin-top: 30px !important;
}

.WhyHostFormBlock1-spaceTop6-VaFVl {
	margin-top: 36px !important;
}

.WhyHostFormBlock1-spaceTop7-_FhFh {
	margin-top: 42px !important;
}

.WhyHostFormBlock1-spaceTop8-KBcHC {
	margin-top: 48px !important;
}

.WhyHostFormBlock1-noMargin-CVR3K {
	margin: 0px !important;
}

.WhyHostFormBlock1-padding1-owQr5 {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock1-padding2-y4k2f {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock1-padding3-BzUxl {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock1-padding4-VdPKd {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock1-padding5-Ct0eM {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock1-padding6-fudee {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock1-padding7-G8Mcx {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock1-paddingTop1-Asj7f {
	padding-top: 6px !important;
}

.WhyHostFormBlock1-paddingTop2-aDNNy {
	padding-top: 12px !important;
}

.WhyHostFormBlock1-paddingTop3-l_9Af {
	padding-top: 18px !important;
}

.WhyHostFormBlock1-paddingTop4-caeHw {
	padding-top: 24px !important;
}

.WhyHostFormBlock1-paddingTop5-uBUzD {
	padding-top: 30px !important;
}

.WhyHostFormBlock1-paddingTop6-wmg8K {
	padding-top: 36px !important;
}

.WhyHostFormBlock1-paddingTop7-BXxVx {
	padding-top: 42px !important;
}

.WhyHostFormBlock1-noPadding-vr4mJ {
	padding: 0px !important;
}

.WhyHostFormBlock1-spaceMarginBottom0-YaSLN {
	margin-bottom: 0;
}

.WhyHostFormBlock1-textBold-STVOH {
	font-weight: 500 !important;
}

.WhyHostFormBlock1-textBolder-zEf2C {
	font-weight: 700 !important;
}

.WhyHostFormBlock1-textNormal-_R21C {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock1-textDarkBlue-w4YPp {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock1-textLightBlue-Q0R3z {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock1-textLightSandleGreen-MshCf {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock1-textLightBrown-fytrb {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock1-textMediumMaroon-D_QZT {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock1-textBrown-O4Q4v {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock1-textMaroon-v3FdS {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock1-textDarkBrown-fwoJD {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock1-textMediumBrown-CyFr8 {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock1-textSkyBlue-A77RW {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock1-textGray-qwg2m {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock1-errorMessage-RJGqa {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock1-userText-qu7CN {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock1-panelHeader-ynJmC {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock1-exportSection-NAxOV {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock1-exportSectionGridSub-O2xai {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock1-exportText-J6f8J {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock1-exportLinkImg-h6KyB {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock1-exportImg-rvOr7 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock1-linkBtn-Y9fqu {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock1-table-YXKYQ {
	display: table;
}

.WhyHostFormBlock1-tableRow-o9GjF {
	display: table-row;
}

.WhyHostFormBlock1-tableCell-qBZ1f {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock1-formGroup-sZMvP {
	margin-bottom: 6px;
}

.WhyHostFormBlock1-marginTop0-yZNOo {
	margin-top: 0;
}

.WhyHostFormBlock1-marginBottom20-yaueg {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock1-bannerImageBg-VOh9U {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock1-bannerDelete-MbqJu {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock1-exportLink-TYAUQ {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock1-seachContent-X9RFZ {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock1-marginBottom9-AmLRd {
	margin-bottom: 9px;
}

.WhyHostFormBlock1-spaceTop52-jjRP_ {
	margin-top: 52px;
}

.WhyHostFormBlock1-profileViewInner-pMe5X {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock1-profileViewMain-TPBpb {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock1-profileViewlabel-QmBM9 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock1-profileViewMainContent-f1kM4 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock1-reviewsFormStar-PLZBo {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock1-reviewsFormStar-PLZBo svg {
	cursor: pointer;
}

.WhyHostFormBlock1-addLanguageText-YHTuR {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock1-exportSection-NAxOV {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock1-spaceTop52-jjRP_ {
		margin-top: 18px;
	}

	.WhyHostFormBlock1-exportText-J6f8J {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock1-exportSectionGridSub-O2xai {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock1-profileViewlabel-QmBM9 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock1-profileViewMainContent-f1kM4 {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock1-panelHeader-ynJmC {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock1-space1-wT1jy`,
	"space2": `WhyHostFormBlock1-space2-hM07m`,
	"space3": `WhyHostFormBlock1-space3-ZWyvZ`,
	"space4": `WhyHostFormBlock1-space4-kIDpD`,
	"space5": `WhyHostFormBlock1-space5-MsCty`,
	"space6": `WhyHostFormBlock1-space6-xMXbQ`,
	"space7": `WhyHostFormBlock1-space7-hsluk`,
	"space8": `WhyHostFormBlock1-space8-ls0zu`,
	"spaceTop1": `WhyHostFormBlock1-spaceTop1-a7BVs`,
	"spaceTop2": `WhyHostFormBlock1-spaceTop2-yq5NB`,
	"spaceTop3": `WhyHostFormBlock1-spaceTop3-hvqan`,
	"spaceTop4": `WhyHostFormBlock1-spaceTop4-N9ihC`,
	"spaceTop5": `WhyHostFormBlock1-spaceTop5-wSB1Z`,
	"spaceTop6": `WhyHostFormBlock1-spaceTop6-VaFVl`,
	"spaceTop7": `WhyHostFormBlock1-spaceTop7-_FhFh`,
	"spaceTop8": `WhyHostFormBlock1-spaceTop8-KBcHC`,
	"noMargin": `WhyHostFormBlock1-noMargin-CVR3K`,
	"padding1": `WhyHostFormBlock1-padding1-owQr5`,
	"padding2": `WhyHostFormBlock1-padding2-y4k2f`,
	"padding3": `WhyHostFormBlock1-padding3-BzUxl`,
	"padding4": `WhyHostFormBlock1-padding4-VdPKd`,
	"padding5": `WhyHostFormBlock1-padding5-Ct0eM`,
	"padding6": `WhyHostFormBlock1-padding6-fudee`,
	"padding7": `WhyHostFormBlock1-padding7-G8Mcx`,
	"paddingTop1": `WhyHostFormBlock1-paddingTop1-Asj7f`,
	"paddingTop2": `WhyHostFormBlock1-paddingTop2-aDNNy`,
	"paddingTop3": `WhyHostFormBlock1-paddingTop3-l_9Af`,
	"paddingTop4": `WhyHostFormBlock1-paddingTop4-caeHw`,
	"paddingTop5": `WhyHostFormBlock1-paddingTop5-uBUzD`,
	"paddingTop6": `WhyHostFormBlock1-paddingTop6-wmg8K`,
	"paddingTop7": `WhyHostFormBlock1-paddingTop7-BXxVx`,
	"noPadding": `WhyHostFormBlock1-noPadding-vr4mJ`,
	"spaceMarginBottom0": `WhyHostFormBlock1-spaceMarginBottom0-YaSLN`,
	"textBold": `WhyHostFormBlock1-textBold-STVOH`,
	"textBolder": `WhyHostFormBlock1-textBolder-zEf2C`,
	"textNormal": `WhyHostFormBlock1-textNormal-_R21C`,
	"textDarkBlue": `WhyHostFormBlock1-textDarkBlue-w4YPp`,
	"textLightBlue": `WhyHostFormBlock1-textLightBlue-Q0R3z`,
	"textLightSandleGreen": `WhyHostFormBlock1-textLightSandleGreen-MshCf`,
	"textLightBrown": `WhyHostFormBlock1-textLightBrown-fytrb`,
	"textMediumMaroon": `WhyHostFormBlock1-textMediumMaroon-D_QZT`,
	"textBrown": `WhyHostFormBlock1-textBrown-O4Q4v`,
	"textMaroon": `WhyHostFormBlock1-textMaroon-v3FdS`,
	"textDarkBrown": `WhyHostFormBlock1-textDarkBrown-fwoJD`,
	"textMediumBrown": `WhyHostFormBlock1-textMediumBrown-CyFr8`,
	"textSkyBlue": `WhyHostFormBlock1-textSkyBlue-A77RW`,
	"textGray": `WhyHostFormBlock1-textGray-qwg2m`,
	"errorMessage": `WhyHostFormBlock1-errorMessage-RJGqa`,
	"userText": `WhyHostFormBlock1-userText-qu7CN`,
	"panelHeader": `WhyHostFormBlock1-panelHeader-ynJmC`,
	"exportSection": `WhyHostFormBlock1-exportSection-NAxOV`,
	"exportSectionGridSub": `WhyHostFormBlock1-exportSectionGridSub-O2xai`,
	"exportText": `WhyHostFormBlock1-exportText-J6f8J`,
	"exportLinkImg": `WhyHostFormBlock1-exportLinkImg-h6KyB`,
	"exportImg": `WhyHostFormBlock1-exportImg-rvOr7`,
	"linkBtn": `WhyHostFormBlock1-linkBtn-Y9fqu`,
	"table": `WhyHostFormBlock1-table-YXKYQ`,
	"tableRow": `WhyHostFormBlock1-tableRow-o9GjF`,
	"tableCell": `WhyHostFormBlock1-tableCell-qBZ1f`,
	"formGroup": `WhyHostFormBlock1-formGroup-sZMvP`,
	"marginTop0": `WhyHostFormBlock1-marginTop0-yZNOo`,
	"marginBottom20": `WhyHostFormBlock1-marginBottom20-yaueg`,
	"bannerImageBg": `WhyHostFormBlock1-bannerImageBg-VOh9U`,
	"bannerDelete": `WhyHostFormBlock1-bannerDelete-MbqJu`,
	"exportLink": `WhyHostFormBlock1-exportLink-TYAUQ`,
	"seachContent": `WhyHostFormBlock1-seachContent-X9RFZ`,
	"marginBottom9": `WhyHostFormBlock1-marginBottom9-AmLRd`,
	"spaceTop52": `WhyHostFormBlock1-spaceTop52-jjRP_`,
	"profileViewInner": `WhyHostFormBlock1-profileViewInner-pMe5X`,
	"profileViewMain": `WhyHostFormBlock1-profileViewMain-TPBpb`,
	"profileViewlabel": `WhyHostFormBlock1-profileViewlabel-QmBM9`,
	"profileViewMainContent": `WhyHostFormBlock1-profileViewMainContent-f1kM4`,
	"reviewsFormStar": `WhyHostFormBlock1-reviewsFormStar-PLZBo`,
	"addLanguageText": `WhyHostFormBlock1-addLanguageText-YHTuR`
};
module.exports = ___CSS_LOADER_EXPORT___;
